export { ArrowRightCircle as default } from './ArrowRightCircle';
